import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { tagAnatomy } from '@chakra-ui/anatomy';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      color: getThemes(theme).colors.palette.primary[0],
      borderRadius: 6,
      p: 0,
    },
    label: {
      w: 'full',
      fontWeight: 600,
      ml: 3.5,
      whiteSpace: 'nowrap',
    },
  });

const number = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      color: getThemes(theme).colors.palette.primary[100],
      bg: getThemes(theme).colors.palette.primary[0],
      borderRadius: 'full',
      textAlign: 'center',
      p: 0,
      w: 4.5,
      h: 4.5,
    },
    label: {
      m: 0,
    },
  });

const clickable = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      cursor: 'pointer',
      h: 9,
      borderRadius: 'full',
      p: 0,
      borderWidth: 1,
      borderColor: getThemes(theme).colors.palette.neutral[60],
      '&.active': {
        bg: getThemes(theme).colors.palette.neutral[90],
        borderWidth: 1,
        borderColor: getThemes(theme).colors.palette.primary[0],
      },
    },
    label: {
      fontWeight: 500,
    },
  });

export const tagTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    variants: {
      number: number(theme),
      clickable: clickable(theme),
    },
    sizes: {
      xs: {
        container: {
          h: 4.5,
          fontSize: 'xs',
          justifyContent: 'center',
        },
        label: {
          mx: 2,
        },
      },
      lg: {
        container: {
          h: 11,
        },
        label: {
          my: 2,
          mx: 3,
        },
      },
      md: {
        container: {
          h: 8,
        },
        label: {
          my: 2,
          mx: 3,
        },
      },
      sm: {
        container: {
          h: 7,
          color: getThemes(theme).colors.palette.primary[0],
          borderRadius: 6,
          p: 0,
        },
        label: {
          my: 1,
          mx: 1.5,
        },
      },
    },
  });

export default (theme: ThemesKeys) => tagTheme(theme);
